// extracted by mini-css-extract-plugin
export default {"backgroundColor":"Play_backgroundColor__eohRF","timer":"Play_timer__GY+6+"};